module.exports = __webpack_public_path__ + "img/logo.b630942c.png";